module.exports = __webpack_public_path__ + "static/media/blog-hai-prompt@2x.d13fafa8.jpg";